import axios from "axios";
import { React, useState, useEffect, useContext } from "react";
import { MovieIndexContext } from "../../context/MovieIndexContext";
import VideoDesc from "../video-desc/VideoDesc";
import VideoPlayer from "../video-player/VideoPlayer";

import "./VideoContainer.scss";

const VideoContainer = () => {
  const [videoId, setVideoId] = useState([]);
  const [content, setContent] = useState([]);
  const { movieId } = useContext(MovieIndexContext);

  const fetchedMoviesData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/trending/movie/week?api_key=${process.env.REACT_APP_API_KEY}`
    );
    // console.log("MovieList from VideoContainer", data.results);
    setContent(data.results);
  };
  // console.log("videoContainer wla MovieID", movieId);

  useEffect(() => {
    if (movieId >= 0) {
      fetchedMoviesData();
    }
  }, [movieId]);

  const fetchedMoviesVideos = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${content[movieId].id}/videos?api_key=0d5b6447380d8a8161c73ee377404260&language=en-US&append_to_response=videos&with_type=trailer`
    );
    // console.log("MovieVideo", data.results);
    setVideoId(data.results);
  };
  useEffect(() => {
    if (content.length) fetchedMoviesVideos();
    // eslint-disable-next-line
  }, [content]);
  return (
    <div className="video-container">
      <VideoPlayer videoId={videoId} />
      <VideoDesc content={content} />
    </div>
  );
};

export default VideoContainer;
